import React, { useEffect, useState } from 'react'
import {
	Box,
	Circle,
	Collapse,
	Flex,
	Icon,
	Image,
	Portal,
	useDisclosure,
} from '@chakra-ui/react'
import OrgList from './OrgList'
import GreneLogo from '../../../assets/images/grene-logo.png'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'
import { useLoadOrganizationList } from './../../../hooks/asset.hooks'
import { isEmptyObject } from '../../../utils/common.util'
import { useOrganizationContext } from './../../../context/organization.context'
import { AUTH_ORGANIZATION_ID } from '../../../utils/constant'
import { organizationConst } from '../../../utils/action.constant'

const OrganizationMenu = ({ orgImage }) => {
	const currentOrgId = parseInt(localStorage.getItem(AUTH_ORGANIZATION_ID), 10)

	const { isOpen, onToggle } = useDisclosure()
	const { mutate, isLoading, status, data } = useLoadOrganizationList()
	const {
		dispatch,
		state: { orgsColor },
	} = useOrganizationContext()

	const [orgnizationList, setOrgnizationList] = useState([])

	useEffect(() => {
		setOrgListAndColor()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const setOrgListAndColor = () => {
		mutate(
			{},
			{
				onSuccess: res => {
					const {
						data: { status, response },
					} = res
					if (status === 200) {
						const orgs = []
						response.forEach(item => {
							if (item.organization_id !== currentOrgId) orgs.unshift(item)
							else orgs.push(item)
						})

						if (isEmptyObject(orgsColor)) {
							dispatch({
								type: organizationConst.SET_ALL_ORGS_COLOR,
								payload: response,
							})
						}
						setOrgnizationList(orgs)
					}
				},
			}
		)
	}

	const openOrgMenu = () => {
		setOrgListAndColor()
		onToggle()
	}

	return (
		<>
			<Flex cursor='pointer' onClick={openOrgMenu} alignItems='center'>
				<Circle size='2.5rem' bg='white' position='relative'>
					<Image
						maxW='1.5rem'
						maxH='1.5rem'
						objectFit='contain'
						alt='company logo'
						fallbackSrc={GreneLogo}
						src={orgImage}
					/>
					<Portal>
						<Box
							display={isOpen ? 'block' : 'none'}
							position='fixed'
							w='100vw'
							h='100vh'
							inset='0'
							bg='rgba(0, 0, 0, 0.8)'
							cursor='default'
						></Box>
					</Portal>

					<Collapse
						in={isOpen}
						animateOpacity
						style={{ position: 'absolute', top: '100%', right: '-100%' }}
					>
						<Box
							mt='4'
							maxH='70vh'
							overflowY='scroll'
							bg='white'
							borderRadius='0px 0px 15px 15px'
							w='fit-content'
						>
							<OrgList
								orgnizationList={orgnizationList}
								isLoading={isLoading}
							/>
						</Box>
					</Collapse>
				</Circle>
				<Icon
					as={isOpen ? BiChevronUp : BiChevronDown}
					color='white'
					w={5}
					h={5}
				/>
			</Flex>
		</>
	)
}

export default OrganizationMenu
